<template>
  <apexchart
    v-if="series && series.length"
    type="donut"
    width="160"
    height="240"
    :options="chartOptions"
    :series="series"
  />
</template>

<script>
export default {
  props: {
    series: {
      type: Array,
      default: () => [0, 0, 0]
    }
  },

  computed: {
    chartOptions() {
      return {
        labels: ['للبيع', 'للإيجار', 'للاستثمار'],
        colors: ['#3e572e', '#a69057', '#d9822b'],
        dataLabels: { enabled: false },
        legend: { show: false },
        stroke: { width: 0 },
        plotOptions: { pie: { donut: { size: '70%' } } },
        chart: { fontFamily: 'Nohemi, IBM Plex Sans Arabic, sans-serif' }
      };
    }
  }
};
</script>
